import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { faqItems } from '../../shared/constants/app-enums';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  standalone: false,
})
export class FaqComponent implements AfterViewInit {
  faqItems = faqItems;

  private readonly _platformId = inject(PLATFORM_ID);
  private readonly cdRef = inject(ChangeDetectorRef);

  ngAfterViewInit(): void {
    // Force change detection after view init — needed for SSR hydration
    if (isPlatformBrowser(this._platformId)) {
      this.cdRef.detectChanges();
    }
  }
}

